module.exports = __webpack_public_path__ + "static/media/pic4.a49db018.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic4.png
// module id = 233
// module chunks = 0